import { defineMessages } from "react-intl";
export var messages = defineMessages({
  showTooltip: {
    id: "jutro-components.widgets.Tooltip.showtooltip",
    defaultMessage: "Show tooltip"
  }
});